module.exports = __webpack_public_path__ + "img/ics_o_dex_package.41992c2a.svg";